module.exports = __webpack_public_path__ + "src/img/emptyPic.36a80948.png";